import { createAsyncThunk } from '@reduxjs/toolkit';
import assetServiceApiInstance from '../../../../config/assetApiConfig';

// Add Tracking Record
export const addTrackingRecord = createAsyncThunk(
  'assetTracking/addRecord',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.post('/asset-tracking', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to add tracking record');
    }
  }
);

// Update Tracking Record
export const updateTrackingRecord = createAsyncThunk(
  'assetTracking/updateRecord',
  async ({ trackingId, ...data }: any & { trackingId: number }, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.put(`/asset-tracking/${trackingId}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update tracking record');
    }
  }
);

// Update Tracking Status
export const updateTrackingStatus = createAsyncThunk(
  'assetTracking/updateStatus',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.put(`/asset-tracking/status`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update tracking status');
    }
  }
);

// Fetch All Tracking Records
export const fetchTrackingRecords = createAsyncThunk(
  'assetTracking/fetchRecords',
  async (_, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.get('/asset-tracking');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch tracking records');
    }
  }
);

// Fetch Tracking Records by Asset ID
export const fetchTrackingByAssetId = createAsyncThunk(
  'assetTracking/fetchByAssetId',
  async (assetId: number, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.get(`/asset-tracking/asset/${assetId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch tracking data by asset ID');
    }
  }
);

// Delete Tracking Record
export const deleteTrackingRecord = createAsyncThunk(
  'assetTracking/deleteRecord',
  async (trackingId: number, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.delete(`/asset-tracking/${trackingId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete tracking record');
    }
  }
);
